import { Entity } from "app/core/commons/entity";

export class Notification implements Entity {
  id: number;
  title: string;
  body: string;
  redirectTo: string;
  viewed: number;
  payload: string;
  icon: string;
  emittedTime: number;

  constructor(value: Object = {}) {
    Object.assign(this, value);
  }

}

export const isFromConversation = (n: Notification, id: number): boolean => {
  const matches = n.payload.match(/conversationId=\[[0-9]+\]/);
  return matches.length > 0 && +matches[0].split('[').pop().split(']')[0] === id
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/notification.ts